var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ababab","d":"m12 .288 2.833 8.718H24l-7.417 5.389 2.833 8.718L12 17.725l-7.417 5.388 2.833-8.718L0 9.006h9.167z"}));
}

StarInline.defaultProps = {"width":"15","height":"15","viewBox":"0 0 24 24"};

module.exports = StarInline;

StarInline.default = StarInline;
